var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination pt40"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-count":_vm.page_count},on:{"prev-click":_vm.prevClick,"next-click":_vm.nextClick,"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }